import { Badge } from 'antd';

/**
 * A small color swatch used to echo a taxonomy object's tree color across the
 * Object Picker (tree cards, tags, selection/summary lists).
 *
 * Built on antd's standalone `Badge` status indicator so it inherits antd's
 * theming; the `indicator` semantic style is overridden to control size/shape.
 *
 * @param {string} props.color            - dot color (any CSS color)
 * @param {number} [props.size=8]         - width/height in px
 * @param {'square'|'round'} [props.shape='square']
 * @param {object} [props.style]          - extra styles merged onto the indicator
 */
const ColorDot = ({ color, size = 10, shape = 'square', style, ...rest }) => (
	<Badge
		color={color}
		styles={{
			root: {
				display: 'inline-flex',
				alignItems: 'center',
				lineHeight: 1,
			},
			indicator: {
				width: size,
				height: size,
				minWidth: size,
				borderRadius: shape === 'round' ? '50%' : 2,
				boxShadow: 'none',
				position: 'static',
				...style,
			},
		}}
		{...rest}
	/>
);

export default ColorDot;
